import { Link } from "react-router-dom";

export default function StandingItem({ userType }) {
  // Define the list of standing links with their visibility rules
  const items = [
    { label: "TRADE WISE", path: "/StandingTradeWise", show: true },
    { label: "SUPER WISE", path: "/StandingSuperWise", show: userType === 1 },
    { label: "MASTER WISE", path: "/StandingMasterWise", show: [1, 2].includes(userType) },
    { label: "USER WISE", path: "/StandingUserWise", show: [1, 2, 3].includes(userType) },
    { label: "PARKING WISE", path: "/StandingParkingWise", show: true },
  ];

  return (
    <div className="StandingContainer">
      {items
        .filter((item) => item.show)
        .map((item, index, arr) => (
          <Link key={item.path} className="large unselectlink" to={item.path}>
            <div
              className={`StandingText ${
                index !== arr.length - 1 ? "AddBorderStanding" : ""
              }`}
            >
              {item.label}
            </div>
          </Link>
        ))}
    </div>
  );
}
